import request from '@/router/axios'
import env from '@/config/env'

/**
 * 线路绑定编辑
 * @param params
 */
export const save = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer-line/save',
    method: 'POST',
    data: params
  })
}

/**
 * 线路绑定列表
 * @param params
 */
export const getLineBindPage = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer-line/page',
    method: 'POST',
    data: params
  })
}

/**
 * 开票主体详情分页线路
 * @param params
 */
export const getdetailLinePage = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer-line/issuer-line-page',
    method: 'POST',
    data: params
  })
}

/**
 * 线路绑定
 * @param params
 */
export const lineBind = (params) => {
  return request({
    url: env.ferryUrl + '/invoice-issuer-line/save',
    method: 'POST',
    data: params
  })
}
